import React from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';
import { NC_FILE_TYPE_OPTIONS, TYPE_DESCRIPTIONS } from '@components/common/NCFileType/NCFileWizardNoERP/constants';
import { StepTypeSelectionProps, TouchableRenderProps } from '@components/common/NCFileType/NCFileWizardNoERP/types';

const StepTypeSelection: React.FC<StepTypeSelectionProps> = ({ selectedType, onSelectType, loading, C, scale, font }) => {
  return (
    <View style={{ paddingHorizontal: scale(15) }}>
      <Text style={[font.Footnote, { color: C('Label/Light/Tertiary'), paddingLeft: scale(15), marginBottom: scale(5) }]}>
        {i18n.t('SELECT THE NC FILE TYPE')}
      </Text>
      <View
        style={{
          backgroundColor: C('Background/Light/Field lighter'),
          borderRadius: scale(SCREEN_BORDER_RADIUS),
          width: '100%',
          flexDirection: 'row',
          padding: scale(18),
        }}
      >
        {NC_FILE_TYPE_OPTIONS.map((t) => {
          const selected = selectedType === t.icon;
          return (
            <View key={t.icon} style={{ width: '25%', justifyContent: 'center' }}>
              <TouchableElement
                onPress={() => {
                  if (loading) return;
                  onSelectType(t.icon);
                }}
                hitSlop={{ top: 0, bottom: 0, left: 0, right: 0 }}
              >
                {({ boxStyle, pressHoverColor }: TouchableRenderProps) => (
                  <View
                    style={[
                      boxStyle,
                      {
                        width: '100%',
                        alignItems: 'center',
                        paddingVertical: scale(18),
                        borderWidth: scale(2),
                        borderRadius: scale(SCREEN_BORDER_RADIUS),
                        borderColor: selected ? C('Selected/Light/Primary') : 'transparent',
                      },
                    ]}
                  >
                    <Svg icon={`${t.icon}${selected ? 'Active' : 'Inactive'}`} width={scale(48)} height={scale(48)} />
                    <Text style={[{ color: C('Label/Light/Primary'), marginVertical: scale(7) }, font['Subhead 1']]}>{i18n.t(t.name)}</Text>
                    <Svg
                      icon={selected ? 'selected' : 'unselected'}
                      width={scale(22)}
                      height={scale(22)}
                      color={selected ? 'Selected / Light / Primary' : 'Label/Light/Quinary'}
                    />
                  </View>
                )}
              </TouchableElement>
            </View>
          );
        })}
      </View>
      <View style={{ paddingHorizontal: scale(15), marginTop: scale(6) }}>
        <Text style={[{ color: C('Label/Light/Tertiary') }, font.Footnote]}>{i18n.t(TYPE_DESCRIPTIONS[selectedType])}</Text>
      </View>
    </View>
  );
};

export default StepTypeSelection;
